module.exports = __webpack_public_path__ + "img/mode3.ed554151.png";